import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    fallbackLng: "en",
    returnObjects: true,
    debug: false,
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: "/locales/{{lng}}/translation.json",
    },
    interpolation: {
      escapeValue: false,
    },
  })
  .catch((error) => {
    console.error("Error Loading i18", error);
  });

export default i18n;
